import { QueryClient } from "react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: process.env.ENV === "production",
      staleTime: 15 * 1000 * 60
    }
  }
});
